import { Button, styled } from '@mui/material';

export const StyledPurpleButton = styled(Button)`
  background-color: #4c17ad !important;

  &:disabled {
    background-color: #bf9dff !important;
  }
  &:hover {
    background-color: #4c17ad !important;
  }
  min-width: 8px !important;
  min-height: 25px !important;
  color: #ffffff !important;
  text-transform: none !important;

  @media (width <= 850px) {
    width: 100% !important;
    justify-content: center !important;
  }
`;

export const StyledWhiteButton = styled(Button)`
  background-color: #ffffff !important;
  color: #5b5b5b !important;
  border: 1px solid #d6d6d6 !important;
  border-radius: 3px !important;

  &:hover {
    background-color: #ffffff !important;
    color: #5b5b5b !important;
  }

  text-align: center !important;

  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-transform: none !important;
  min-height: 40px !important;
  min-width: 100px !important;
`;

export const StyledGreenButton = styled(Button)`
  background-color: #388000 !important;
  color: #ffffff !important;
  border: 1px solid #d6d6d6 !important;
  border-radius: 3px !important;
  min-width: 150px !important;
  min-height: 40px !important;
  text-transform: none !important;
  box-shadow: none !important;

  &.Mui-disabled {
    background: #83b367e8 !important;
  }
`;

export const ActionbuttonsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  justify-content: space-between;
  margin-left: auto;
  margin-right: 25px;
`;
